import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  //User JSON
  userData$: Observable<any> | undefined;
  user
  selectedFiles: any[] = [];
  integration: String = ''

  ngOnInit(): void {
    this.userData$ = this.oidcSecurityService.userData$;
  }



  products: Array<any> = [
    { "key": "Audaces Isa", "label": "Form.Products.audacesisa" },
    { "key": "Audaces Isa BI", "label": "Form.Products.audacesisabi" },
    { "key": "Audaces Fashion Studio", "label": "Form.Products.audacesfashionstudio" },
    { "key": "Audaces Idea", "label": "Form.Products.audacesidea" },
    { "key": "Audaces Digiflash", "label": "Form.Products.audacesdigiflash" },
    { "key": "Audaces Digiflash XT", "label": "Form.Products.audacesdigiflashxt" },
    { "key": "Audaces Moldes", "label": "Form.Products.audacesmoldes" },
    { "key": "Audaces Encaixe", "label": "Form.Products.audacesencaixe" },
    { "key": "Audaces Supera", "label": "Form.Products.audacessupera" },
    { "key": "Audaces 360", "label": "Form.Products.audaces360" },
    { "key": "Audaces Go", "label": "Form.Products.audacesgo" },
    { "key": "Novo Produto", "label": "Form.Products.novoproduto" },
  ];

  processes: Array<any> = [
    { "key": "10635", "label": "Form.Process.planning" },
    { "key": "10636", "label": "Form.Process.management" },
    { "key": "10891", "label": "Form.Process.style" },
    { "key": "10637", "label": "Form.Process.drawing" },
    { "key": "10638", "label": "Form.Process.sheet" },
    { "key": "10639", "label": "Form.Process.cost" },
    { "key": "10890", "label": "Form.Process.engineering" },
    { "key": "10640", "label": "Form.Process.modeling" },
    { "key": "10641", "label": "Form.Process.fit" },
    { "key": "10892", "label": "Form.Process.production" },
    { "key": "10642", "label": "Form.Process.erp" }
  ];

  benefits: Array<any> = [
    { "key": '10643', "label": "Form.Benefits.revenue" },
    { "key": '10644', "label": "Form.Benefits.deadline" },
    { "key": '10645', "label": "Form.Benefits.cost" },
    { "key": '10646', "label": "Form.Benefits.risk" },
    { "key": '10647', "label": "Form.Benefits.legal" },
    { "key": '10648', "label": "Form.Benefits.stock" },
  ];

  levels: Array<any> = [
    { "key": "Baixo", "label": "Form.Levels.low" },
    { "key": "Médio", "label": "Form.Levels.med" },
    { "key": "Alto", "label": "Form.Levels.high" },
  ];

  levelsF: Array<any> = [
    { "key": "Baixa", "label": "Form.LevelsF.low" },
    { "key": "Média", "label": "Form.LevelsF.med" },
    { "key": "Alta", "label": "Form.LevelsF.high" },
    { "key": "Altíssima", "label": "Form.LevelsF.vhigh" },
  ];

  sectors: Array<any> = [
    { "key": "10756", "label": "Form.Sector.product" },
    { "key": "10795", "label": "Form.Sector.development" },
    { "key": "10739", "label": "Form.Sector.QA" },
    { "key": "10740", "label": "Form.Sector.documentation" },
    { "key": "10742", "label": "Form.Sector.instructors" },
    { "key": "10743", "label": "Form.Sector.projects" },
    { "key": "10741", "label": "Form.Sector.CX" },
    { "key": "10744", "label": "Form.Sector.distributor" },
    { "key": "10745", "label": "Form.Sector.brazilsales" },
    { "key": "10746", "label": "Form.Sector.latamsales" },
    { "key": "10747", "label": "Form.Sector.europesales" },
    { "key": "10748", "label": "Form.Sector.asiansales" },
    { "key": "10749", "label": "Form.Sector.ussales" },
    { "key": "10889", "label": "Form.Sector.support" },
    { "key": "10979", "label": "Form.Sector.desUiUx" },
    { "key": "10983", "label": "Form.Sector.testeFunc" },
    { "key": "10936", "label": "Form.Sector.comiteProduto" },
    { "key": "11227", "label": "Form.Sector.testeAutomatizado" },
    { "key": "11308", "label": "Form.Sector.comercialparcerias" }
  ];

  sectorsClients: Array<any> = [
    { "key": "10893", "label": "Form.SectorClient.commercial" },
    { "key": "10894", "label": "Form.SectorClient.style" },
    { "key": "10895", "label": "Form.SectorClient.engineering" },
    { "key": "10896", "label": "Form.SectorClient.modeling" },
    { "key": "10897", "label": "Form.SectorClient.fitting" },
    { "key": "10898", "label": "Form.SectorClient.piloting" },
    { "key": "10899", "label": "Form.SectorClient.shopping" },
    { "key": "10900", "label": "Form.SectorClient.production" },
    { "key": "10901", "label": "Form.SectorClient.suppliers" },
    { "key": "10902", "label": "Form.SectorClient.laundry" },
    { "key": "10903", "label": "Form.SectorClient.stamping" },
    { "key": "10904", "label": "Form.SectorClient.other" }
  ]

  ClientSolicitation: Array<any> = [
    { "key": "Sim", "label": "Form.ClientSolicit.yes" },
    { "key": "Não", "label": "Form.ClientSolicit.no" }
  ]

  ReturnValues: Array<any> = [
    { "key": "10905", "label": "Form.Return.05" },
    { "key": "10906", "label": "Form.Return.5100" },
    { "key": "10907", "label": "Form.Return.100500" },
    { "key": "10908", "label": "Form.Return.5001" },
    { "key": "10909", "label": "Form.Return.110" },
    { "key": "10910", "label": "Form.Return.10100" },
    { "key": "10911", "label": "Form.Return.+100" }
  ]

  subjects: Array<any> = [
    {
      "key": "10996",
      "label": "Form.subjects.10996",
      "project": "Audaces Isa",
      "assunto": "Relatórios"
    },
    {
      "key": "10997",
      "label": "Form.subjects.10997",
      "project": "Audaces Isa",
      "assunto": "Filtros "
    },
    {
      "key": "10998",
      "label": "Form.subjects.10998",
      "project": "Audaces Isa",
      "assunto": "Configurações empresa "
    },
    {
      "key": "10999",
      "label": "Form.subjects.10999",
      "project": "Audaces Isa",
      "assunto": "Kanban"
    },
    {
      "key": "11000",
      "label": "Form.subjects.11000",
      "project": "Audaces Isa",
      "assunto": "Fluxo de etapas"
    },
    {
      "key": "11001",
      "label": "Form.subjects.11001",
      "project": "Audaces Isa",
      "assunto": "Notificações "
    },
    {
      "key": "11002",
      "label": "Form.subjects.11002",
      "project": "Audaces Isa",
      "assunto": "Exportação de informações"
    },
    {
      "key": "11003",
      "label": "Form.subjects.11003",
      "project": "Audaces Isa",
      "assunto": "Importação de informações"
    },
    {
      "key": "11004",
      "label": "Form.subjects.11004",
      "project": "Audaces Isa",
      "assunto": "Edição de modelos "
    },
    {
      "key": "11005",
      "label": "Form.subjects.11005",
      "project": "Audaces Isa",
      "assunto": "Planejamento de coleção"
    },
    {
      "key": "11006",
      "label": "Form.subjects.11006",
      "project": "Audaces Isa BI",
      "assunto": "Relatório de equipe "
    },
    {
      "key": "11007",
      "label": "Form.subjects.11007",
      "project": "Audaces Isa BI",
      "assunto": "Relatório de etapas "
    },
    {
      "key": "11008",
      "label": "Form.subjects.11008",
      "project": "Audaces Isa BI",
      "assunto": "Relatório de modelo "
    },
    {
      "key": "11009",
      "label": "Form.subjects.11009",
      "project": "Audaces Isa BI",
      "assunto": "Acompanhamento Realtime"
    },
    {
      "key": "11010",
      "label": "Form.subjects.11010",
      "project": "Audaces Isa BI",
      "assunto": "Leadtime de modelos/coleções"
    },
    {
      "key": "11011",
      "label": "Form.subjects.11011",
      "project": "Audaces Idea",
      "assunto": "Tabelas"
    },
    {
      "key": "11012",
      "label": "Form.subjects.11012",
      "project": "Audaces Idea",
      "assunto": "Referências de materiais"
    },
    {
      "key": "11013",
      "label": "Form.subjects.11013",
      "project": "Audaces Idea",
      "assunto": "Referência de atividades"
    },
    {
      "key": "11014",
      "label": "Form.subjects.11014",
      "project": "Audaces Idea",
      "assunto": "Referência de medidas "
    },
    {
      "key": "11015",
      "label": "Form.subjects.11015",
      "project": "Audaces Idea",
      "assunto": "Referência de modelo"
    },
    {
      "key": "11016",
      "label": "Form.subjects.11016",
      "project": "Audaces Idea",
      "assunto": "Variantes"
    },
    {
      "key": "11037",
      "label": "Form.subjects.11037",
      "project": "Audaces Idea",
      "assunto": "Formas"
    },
    {
      "key": "11038",
      "label": "Form.subjects.11038",
      "project": "Audaces Idea",
      "assunto": "Manequins"
    },
    {
      "key": "11022",
      "label": "Form.subjects.11022",
      "project": "Audaces Idea",
      "assunto": "Importação"
    },
    {
      "key": "11039",
      "label": "Form.subjects.11039",
      "project": "Audaces Idea",
      "assunto": "Instalação"
    },
    {
      "key": "11040",
      "label": "Form.subjects.11040",
      "project": "Audaces Idea",
      "assunto": "Atualização"
    },
    {
      "key": "11021",
      "label": "Form.subjects.11021",
      "project": "Audaces Encaixe",
      "assunto": "Salvamento"
    },
    {
      "key": "11023",
      "label": "Form.subjects.11023",
      "project": "Audaces Encaixe",
      "assunto": "Exportação"
    },
    {
      "key": "11024",
      "label": "Form.subjects.11024",
      "project": "Audaces Encaixe",
      "assunto": "Plotar/ Imprimir"
    },
    {
      "key": "11044",
      "label": "Form.subjects.11044",
      "project": "Audaces Encaixe",
      "assunto": "ISO"
    },
    {
      "key": "11045",
      "label": "Form.subjects.11045",
      "project": "Audaces Encaixe",
      "assunto": "Audaces Encaixe automático"
    },
    {
      "key": "11046",
      "label": "Form.subjects.11046",
      "project": "Audaces Encaixe",
      "assunto": "Audaces Encaixe Audaces Supera"
    },
    {
      "key": "11047",
      "label": "Form.subjects.11047",
      "project": "Audaces Encaixe",
      "assunto": "Audaces Encaixe em blocos"
    },
    {
      "key": "11048",
      "label": "Form.subjects.11048",
      "project": "Audaces Encaixe",
      "assunto": "Envolventes"
    },
    {
      "key": "11049",
      "label": "Form.subjects.11049",
      "project": "Audaces Encaixe",
      "assunto": "Snap"
    },
    {
      "key": "11050",
      "label": "Form.subjects.11050",
      "project": "Audaces Supera",
      "assunto": "Aproveitamento"
    },
    {
      "key": "11021",
      "label": "Form.subjects.11021",
      "project": "Audaces Supera",
      "assunto": "Salvamento"
    },
    {
      "key": "11051",
      "label": "Form.subjects.11051",
      "project": "Audaces Supera",
      "assunto": "Coprocessador"
    },
    {
      "key": "11017",
      "label": "Form.subjects.11017",
      "project": "Audaces Digiflash",
      "assunto": "Câmera"
    },
    {
      "key": "11018",
      "label": "Form.subjects.11018",
      "project": "Audaces Digiflash",
      "assunto": "Captura de imagem"
    },
    {
      "key": "11019",
      "label": "Form.subjects.11019",
      "project": "Audaces Digiflash",
      "assunto": "Processamento de Audaces Moldes"
    },
    {
      "key": "11020",
      "label": "Form.subjects.11020",
      "project": "Audaces Digiflash",
      "assunto": "Manipulação de Audaces Moldes"
    },
    {
      "key": "11021",
      "label": "Form.subjects.11021",
      "project": "Audaces Moldes",
      "assunto": "Salvamento"
    },
    {
      "key": "11022",
      "label": "Form.subjects.11022",
      "project": "Audaces Moldes",
      "assunto": "Importação"
    },
    {
      "key": "11023",
      "label": "Form.subjects.11023",
      "project": "Audaces Moldes",
      "assunto": "Exportação"
    },
    {
      "key": "11024",
      "label": "Form.subjects.11024",
      "project": "Audaces Moldes",
      "assunto": "Plotar/ Imprimir"
    },
    {
      "key": "11025",
      "label": "Form.subjects.11025",
      "project": "Audaces Moldes",
      "assunto": "Criação de Audaces Moldes"
    },
    {
      "key": "11026",
      "label": "Form.subjects.11026",
      "project": "Audaces Moldes",
      "assunto": "Produção dos Audaces Moldes"
    },
    {
      "key": "11027",
      "label": "Form.subjects.11027",
      "project": "Audaces Moldes",
      "assunto": "Piques"
    },
    {
      "key": "11028",
      "label": "Form.subjects.11028",
      "project": "Audaces Moldes",
      "assunto": "Estamparia corrida"
    },
    {
      "key": "11029",
      "label": "Form.subjects.11029",
      "project": "Audaces Moldes",
      "assunto": "Estamparia Localizada"
    },
    {
      "key": "11030",
      "label": "Form.subjects.11030",
      "project": "Audaces Moldes",
      "assunto": "Graduação "
    },
    {
      "key": "11020",
      "label": "Form.subjects.11020",
      "project": "Audaces Moldes",
      "assunto": "Manipulação de Audaces Moldes"
    },
    {
      "key": "11031",
      "label": "Form.subjects.11031",
      "project": "Audaces Moldes",
      "assunto": "Conferência de Audaces Moldes"
    },
    {
      "key": "11032",
      "label": "Form.subjects.11032",
      "project": "Audaces Moldes",
      "assunto": "Tabela de medidas"
    },
    {
      "key": "11033",
      "label": "Form.subjects.11033",
      "project": "Audaces Moldes",
      "assunto": "Relatórios Audaces Moldes"
    },
    {
      "key": "11056",
      "label": "Form.subjects.11056",
      "project": "Audaces Fashion Studio",
      "assunto": "Simulação de tecido"
    },
    {
      "key": "11057",
      "label": "Form.subjects.11057",
      "project": "Audaces Fashion Studio",
      "assunto": "Desfile"
    },
    {
      "key": "11058",
      "label": "Form.subjects.11058",
      "project": "Audaces Fashion Studio",
      "assunto": "Showroom"
    },
    {
      "key": "11059",
      "label": "Form.subjects.11059",
      "project": "Audaces Fashion Studio",
      "assunto": "Sala de prova"
    },
    {
      "key": "11035",
      "label": "Form.subjects.11035",
      "project": "Audaces Fashion Studio",
      "assunto": "Estampas"
    },
    {
      "key": "11036",
      "label": "Form.subjects.11036",
      "project": "Audaces Fashion Studio",
      "assunto": "Aviamentos/Acessórios"
    },
    {
      "key": "11022",
      "label": "Form.subjects.11022",
      "project": "Audaces Fashion Studio",
      "assunto": "Importação"
    },
    {
      "key": "11023",
      "label": "Form.subjects.11023",
      "project": "Audaces Fashion Studio",
      "assunto": "Exportação"
    },
    {
      "key": "11038",
      "label": "Form.subjects.11038",
      "project": "Audaces Fashion Studio",
      "assunto": "Manequins"
    },
    {
      "key": "11060",
      "label": "Form.subjects.11060",
      "project": "Audaces Fashion Studio",
      "assunto": "Ferramentas/ Criação"
    },
    {
      "key": "11052",
      "label": "Form.subjects.11052",
      "project": "Audaces 360",
      "assunto": "Integração com ERP"
    },
    {
      "key": "11053",
      "label": "Form.subjects.11053",
      "project": "Audaces 360",
      "assunto": "Integração A360"
    },
    {
      "key": "11039",
      "label": "Form.subjects.11039",
      "project": "Audaces 360",
      "assunto": "Instalação"
    },
    {
      "key": "11040",
      "label": "Form.subjects.11040",
      "project": "Audaces 360",
      "assunto": "Atualização"
    },
    {
      "key": "11041",
      "label": "Form.subjects.11041",
      "project": "Audaces 360",
      "assunto": "Perfil"
    },
    {
      "key": "11042",
      "label": "Form.subjects.11042",
      "project": "Audaces 360",
      "assunto": "Licenças"
    },
    {
      "key": "11043",
      "label": "Form.subjects.11043",
      "project": "Audaces 360",
      "assunto": "Financeiro"
    }
  ]

  CountryValues: Array<any> = [
    {
      "key": "Afeganistão",
      "label": "Form.countries.AF"
    },
    {
      "key": "África do Sul",
      "label": "Form.countries.ZA"
    },
    {
      "key": "Albânia",
      "label": "Form.countries.AL"
    },
    {
      "key": "Alemanha",
      "label": "Form.countries.DE"
    },
    {
      "key": "Andorra",
      "label": "Form.countries.AD"
    },
    {
      "key": "Angola",
      "label": "Form.countries.AO"
    },
    {
      "key": "Antígua e Barbuda",
      "label": "Form.countries.AG"
    },
    {
      "key": "Antilhas Holandesas",
      "label": "Form.countries.AN"
    },
    {
      "key": "Arábia Saudita",
      "label": "Form.countries.SA"
    },
    {
      "key": "Argélia",
      "label": "Form.countries.DZ"
    },
    {
      "key": "Argentina",
      "label": "Form.countries.AR"
    },
    {
      "key": "Armênia",
      "label": "Form.countries.AM"
    },
    {
      "key": "Aruba",
      "label": "Form.countries.AW"
    },
    {
      "key": "Austrália",
      "label": "Form.countries.AU"
    },
    {
      "key": "Áustria",
      "label": "Form.countries.AT"
    },
    {
      "key": "Azerbaijão",
      "label": "Form.countries.AZ"
    },
    {
      "key": "Bahamas",
      "label": "Form.countries.BS"
    },
    {
      "key": "Bangladesh",
      "label": "Form.countries.BD"
    },
    {
      "key": "Barbados",
      "label": "Form.countries.BB"
    },
    {
      "key": "Barein",
      "label": "Form.countries.BH"
    },
    {
      "key": "Bélgica",
      "label": "Form.countries.BE"
    },
    {
      "key": "Belize",
      "label": "Form.countries.BZ"
    },
    {
      "key": "Benin",
      "label": "Form.countries.BJ"
    },
    {
      "key": "Bermuda",
      "label": "Form.countries.BM"
    },
    {
      "key": "Bielorrússia",
      "label": "Form.countries.BY"
    },
    {
      "key": "Bolívia",
      "label": "Form.countries.BO"
    },
    {
      "key": "Bósnia Herzegovina",
      "label": "Form.countries.BA"
    },
    {
      "key": "Botsuana",
      "label": "Form.countries.BW"
    },
    {
      "key": "Brasil",
      "label": "Form.countries.BR"
    },
    {
      "key": "Brunei",
      "label": "Form.countries.BN"
    },
    {
      "key": "Bulgária",
      "label": "Form.countries.BG"
    },
    {
      "key": "Burkina Fasso",
      "label": "Form.countries.BF"
    },
    {
      "key": "Burundi",
      "label": "Form.countries.BI"
    },
    {
      "key": "Butão",
      "label": "Form.countries.BT"
    },
    {
      "key": "Cabo Verde",
      "label": "Form.countries.CV"
    },
    {
      "key": "Camarões",
      "label": "Form.countries.CM"
    },
    {
      "key": "Camboja",
      "label": "Form.countries.KH"
    },
    {
      "key": "Canadá",
      "label": "Form.countries.CA"
    },
    {
      "key": "Catar",
      "label": "Form.countries.QA"
    },
    {
      "key": "Cazaquistão",
      "label": "Form.countries.KZ"
    },
    {
      "key": "Chade",
      "label": "Form.countries.TD"
    },
    {
      "key": "Chile",
      "label": "Form.countries.CL"
    },
    {
      "key": "China",
      "label": "Form.countries.CN"
    },
    {
      "key": "Chipre",
      "label": "Form.countries.CY"
    },
    {
      "key": "Colômbia",
      "label": "Form.countries.CO"
    },
    {
      "key": "Congo",
      "label": "Form.countries.CG"
    },
    {
      "key": "Coréia do Norte",
      "label": "Form.countries.KP"
    },
    {
      "key": "Coréia do Sul",
      "label": "Form.countries.KR"
    },
    {
      "key": "Costa do Marfim",
      "label": "Form.countries.CI"
    },
    {
      "key": "Costa Rica",
      "label": "Form.countries.CR"
    },
    {
      "key": "Croácia",
      "label": "Form.countries.HR"
    },
    {
      "key": "Cuba",
      "label": "Form.countries.CU"
    },
    {
      "key": "Curaçao",
      "label": "Form.countries.CW"
    },
    {
      "key": "Dinamarca",
      "label": "Form.countries.DK"
    },
    {
      "key": "Djibuti",
      "label": "Form.countries.DJ"
    },
    {
      "key": "Dominica",
      "label": "Form.countries.DM"
    },
    {
      "key": "Egito",
      "label": "Form.countries.EG"
    },
    {
      "key": "El Salvador",
      "label": "Form.countries.SV"
    },
    {
      "key": "Emirados Árabes",
      "label": "Form.countries.AE"
    },
    {
      "key": "Equador",
      "label": "Form.countries.EC"
    },
    {
      "key": "Eritréia",
      "label": "Form.countries.ER"
    },
    {
      "key": "Eslováquia",
      "label": "Form.countries.SK"
    },
    {
      "key": "Eslovênia",
      "label": "Form.countries.SI"
    },
    {
      "key": "Espanha",
      "label": "Form.countries.ES"
    },
    {
      "key": "Estados Unidos",
      "label": "Form.countries.US"
    },
    {
      "key": "Estônia",
      "label": "Form.countries.EE"
    },
    {
      "key": "Etiópia",
      "label": "Form.countries.ET"
    },
    {
      "key": "Fiji",
      "label": "Form.countries.FJ"
    },
    {
      "key": "Filipinas",
      "label": "Form.countries.PH"
    },
    {
      "key": "Finlândia",
      "label": "Form.countries.FI"
    },
    {
      "key": "França",
      "label": "Form.countries.FR"
    },
    {
      "key": "Gabão",
      "label": "Form.countries.GA"
    },
    {
      "key": "Gâmbia",
      "label": "Form.countries.GM"
    },
    {
      "key": "Gana",
      "label": "Form.countries.GH"
    },
    {
      "key": "Gibraltar",
      "label": "Form.countries.GI"
    },
    {
      "key": "Granada",
      "label": "Form.countries.GD"
    },
    {
      "key": "Grécia",
      "label": "Form.countries.GR"
    },
    {
      "key": "Groenlândia",
      "label": "Form.countries.GL"
    },
    {
      "key": "Guadalupe",
      "label": "Form.countries.GP"
    },
    {
      "key": "Guam",
      "label": "Form.countries.GU"
    },
    {
      "key": "Guatemala",
      "label": "Form.countries.GT"
    },
    {
      "key": "Guiana",
      "label": "Form.countries.GY"
    },
    {
      "key": "Guiana Francesa",
      "label": "Form.countries.GF"
    },
    {
      "key": "Guiné",
      "label": "Form.countries.GN"
    },
    {
      "key": "Guiné Equatorial",
      "label": "Form.countries.GQ"
    },
    {
      "key": "Guiné-Bissau",
      "label": "Form.countries.GW"
    },
    {
      "key": "Haiti",
      "label": "Form.countries.HT"
    },
    {
      "key": "Holanda",
      "label": "Form.countries.NL"
    },
    {
      "key": "Honduras",
      "label": "Form.countries.HN"
    },
    {
      "key": "Hong Kong",
      "label": "Form.countries.HK"
    },
    {
      "key": "Hungria",
      "label": "Form.countries.HU"
    },
    {
      "key": "Iêmen",
      "label": "Form.countries.YE"
    },
    {
      "key": "Índia",
      "label": "Form.countries.IN"
    },
    {
      "key": "Indonésia",
      "label": "Form.countries.ID"
    },
    {
      "key": "Inglaterra",
      "label": "Form.countries.IG"
    },
    {
      "key": "Irã",
      "label": "Form.countries.IR"
    },
    {
      "key": "Iraque",
      "label": "Form.countries.IQ"
    },
    {
      "key": "Irlanda",
      "label": "Form.countries.IE"
    },
    {
      "key": "Islândia",
      "label": "Form.countries.IS"
    },
    {
      "key": "Israel",
      "label": "Form.countries.IL"
    },
    {
      "key": "Itália",
      "label": "Form.countries.IT"
    },
    {
      "key": "Iugoslavia",
      "label": "Form.countries.YU"
    },
    {
      "key": "Jamaica",
      "label": "Form.countries.JM"
    },
    {
      "key": "Japão",
      "label": "Form.countries.JP"
    },
    {
      "key": "Jordânia",
      "label": "Form.countries.JO"
    },
    {
      "key": "Kiribati",
      "label": "Form.countries.KI"
    },
    {
      "key": "Kuweit",
      "label": "Form.countries.KW"
    },
    {
      "key": "Laos",
      "label": "Form.countries.LA"
    },
    {
      "key": "Lesoto",
      "label": "Form.countries.LS"
    },
    {
      "key": "Letônia",
      "label": "Form.countries.LV"
    },
    {
      "key": "Líbano",
      "label": "Form.countries.LB"
    },
    {
      "key": "Libéria",
      "label": "Form.countries.LR"
    },
    {
      "key": "Libia",
      "label": "Form.countries.LY"
    },
    {
      "key": "Liechtenstein",
      "label": "Form.countries.LI"
    },
    {
      "key": "Lituânia",
      "label": "Form.countries.LT"
    },
    {
      "key": "Luxemburgo",
      "label": "Form.countries.LU"
    },
    {
      "key": "Macedônia",
      "label": "Form.countries.MK"
    },
    {
      "key": "Madagascar",
      "label": "Form.countries.MG"
    },
    {
      "key": "Malásia",
      "label": "Form.countries.MY"
    },
    {
      "key": "Malauí",
      "label": "Form.countries.MW"
    },
    {
      "key": "Maldivas",
      "label": "Form.countries.MV"
    },
    {
      "key": "Mali",
      "label": "Form.countries.ML"
    },
    {
      "key": "Malta",
      "label": "Form.countries.MT"
    },
    {
      "key": "Marrocos",
      "label": "Form.countries.MA"
    },
    {
      "key": "Martinica",
      "label": "Form.countries.MQ"
    },
    {
      "key": "Maurícia",
      "label": "Form.countries.IM"
    },
    {
      "key": "Mauritânia",
      "label": "Form.countries.MR"
    },
    {
      "key": "Mayotte",
      "label": "Form.countries.YT"
    },
    {
      "key": "México",
      "label": "Form.countries.MX"
    },
    {
      "key": "Mianmar",
      "label": "Form.countries.MM"
    },
    {
      "key": "Micronésia",
      "label": "Form.countries.FM"
    },
    {
      "key": "Moçambique",
      "label": "Form.countries.MZ"
    },
    {
      "key": "Moldávia",
      "label": "Form.countries.MD"
    },
    {
      "key": "Mônaco",
      "label": "Form.countries.MC"
    },
    {
      "key": "Mongólia",
      "label": "Form.countries.MN"
    },
    {
      "key": "Montenegro",
      "label": "Form.countries.ME"
    },
    {
      "key": "Montserrat",
      "label": "Form.countries.MS"
    },
    {
      "key": "Namíbia",
      "label": "Form.countries.NA"
    },
    {
      "key": "Nauru",
      "label": "Form.countries.NR"
    },
    {
      "key": "Nepal",
      "label": "Form.countries.NP"
    },
    {
      "key": "Nicarágua",
      "label": "Form.countries.NI"
    },
    {
      "key": "Níger",
      "label": "Form.countries.NE"
    },
    {
      "key": "Nigéria",
      "label": "Form.countries.NG"
    },
    {
      "key": "Niue",
      "label": "Form.countries.NU"
    },
    {
      "key": "Noruega",
      "label": "Form.countries.NO"
    },
    {
      "key": "Nova Caledônia",
      "label": "Form.countries.NC"
    },
    {
      "key": "Nova Zelândia",
      "label": "Form.countries.NZ"
    },
    {
      "key": "Omã",
      "label": "Form.countries.OM"
    },
    {
      "key": "Palestina",
      "label": "Form.countries.PS"
    },
    {
      "key": "Panamá",
      "label": "Form.countries.PA"
    },
    {
      "key": "Papua-Nova Guiné",
      "label": "Form.countries.PG"
    },
    {
      "key": "Paquistão",
      "label": "Form.countries.PK"
    },
    {
      "key": "Paraguai",
      "label": "Form.countries.PY"
    },
    {
      "key": "Peru",
      "label": "Form.countries.PE"
    },
    {
      "key": "Pitcairn",
      "label": "Form.countries.PN"
    },
    {
      "key": "Polinésia",
      "label": "Form.countries.PF"
    },
    {
      "key": "Polônia",
      "label": "Form.countries.PL"
    },
    {
      "key": "Portugal",
      "label": "Form.countries.PT"
    },
    {
      "key": "Quênia",
      "label": "Form.countries.KE"
    },
    {
      "key": "Quirguistão",
      "label": "Form.countries.KG"
    },
    {
      "key": "Reino Unido",
      "label": "Form.countries.GB"
    },
    {
      "key": "República Centro-Africana",
      "label": "Form.countries.CF"
    },
    {
      "key": "República da Geórgia",
      "label": "Form.countries.GE"
    },
    {
      "key": "República Democrática do Congo",
      "label": "Form.countries.CD"
    },
    {
      "key": "República Dominicana",
      "label": "Form.countries.DO"
    },
    {
      "key": "República Tcheca",
      "label": "Form.countries.CZ"
    },
    {
      "key": "Romênia",
      "label": "Form.countries.RO"
    },
    {
      "key": "Ruanda",
      "label": "Form.countries.RW"
    },
    {
      "key": "Rússia",
      "label": "Form.countries.RU"
    },
    {
      "key": "Saara Ocidental",
      "label": "Form.countries.EH"
    },
    {
      "key": "Saint Barthélemy",
      "label": "Form.countries.BL"
    },
    {
      "key": "Samoa Americana",
      "label": "Form.countries.AS"
    },
    {
      "key": "Samoa Ocidental",
      "label": "Form.countries.WS"
    },
    {
      "key": "San Marino",
      "label": "Form.countries.SM"
    },
    {
      "key": "Santa Helena",
      "label": "Form.countries.SH"
    },
    {
      "key": "Santa Lúcia",
      "label": "Form.countries.LC"
    },
    {
      "key": "São Cristóvão e Névis",
      "label": "Form.countries.KN"
    },
    {
      "key": "São Martinho",
      "label": "Form.countries.TS"
    },
    {
      "key": "São Vicente e Granadinas",
      "label": "Form.countries.VC"
    },
    {
      "key": "Seicheles",
      "label": "Form.countries.YC"
    },
    {
      "key": "Senegal",
      "label": "Form.countries.SN"
    },
    {
      "key": "Serra",
      "label": "Form.countries.SL"
    },
    {
      "key": "Servia",
      "label": "Form.countries.RS"
    },
    {
      "key": "Singapura",
      "label": "Form.countries.SG"
    },
    {
      "key": "Síria",
      "label": "Form.countries.SY"
    },
    {
      "key": "Somália",
      "label": "Form.countries.SO"
    },
    {
      "key": "Sri",
      "label": "Form.countries.LK"
    },
    {
      "key": "Suazilândia",
      "label": "Form.countries.SZ"
    },
    {
      "key": "Sudão",
      "label": "Form.countries.SD"
    },
    {
      "key": "Sudão",
      "label": "Form.countries.SS"
    },
    {
      "key": "Suécia",
      "label": "Form.countries.SE"
    },
    {
      "key": "Suíça",
      "label": "Form.countries.CH"
    },
    {
      "key": "Suriname",
      "label": "Form.countries.SR"
    },
    {
      "key": "Tadjiquistão",
      "label": "Form.countries.TJ"
    },
    {
      "key": "Tailândia",
      "label": "Form.countries.TH"
    },
    {
      "key": "Taiwan",
      "label": "Form.countries.TW"
    },
    {
      "key": "Tanzânia",
      "label": "Form.countries.TZ"
    },
    {
      "key": "Timor-Leste",
      "label": "Form.countries.TL"
    },
    {
      "key": "Togo",
      "label": "Form.countries.TG"
    },
    {
      "key": "Tokelau",
      "label": "Form.countries.TK"
    },
    {
      "key": "Tonga",
      "label": "Form.countries.TO"
    },
    {
      "key": "Tunísia",
      "label": "Form.countries.TN"
    },
    {
      "key": "Turcomenistão",
      "label": "Form.countries.TM"
    },
    {
      "key": "Turquia",
      "label": "Form.countries.TR"
    },
    {
      "key": "Tuvalu",
      "label": "Form.countries.TV"
    },
    {
      "key": "Ucrânia",
      "label": "Form.countries.UA"
    },
    {
      "key": "Uganda",
      "label": "Form.countries.UG"
    },
    {
      "key": "Uruguai",
      "label": "Form.countries.UY"
    },
    {
      "key": "Uzbequistão",
      "label": "Form.countries.UZ"
    },
    {
      "key": "Vanuatu",
      "label": "Form.countries.VU"
    },
    {
      "key": "Venezuela",
      "label": "Form.countries.VE"
    },
    {
      "key": "Vietnã",
      "label": "Form.countries.VN"
    },
    {
      "key": "Zâmbia",
      "label": "Form.countries.ZM"
    },
    {
      "key": "Zimbábue",
      "label": "Form.countries.ZW"
    },
    {
      "key": "Vietnã",
      "label": "Form.countries.VN"
    },
    {
      "key": "Zâmbia",
      "label": "Form.countries.ZM"
    },
    {
      "key": "Zimbábue",
      "label": "Form.countries.ZW"
    }
  ]

  typeSolicitation: Array<any> = [
    {
      "key": "true",
      "label": "Form.typeSolicitations.integration"
    },
    // {
    //   "key": "true",
    //   "label": "Form.typeSolicitations.production"
    // },
    // {
    //   "key": "false",
    //   "label": "Form.typeSolicitations.cddp"
    // }
  ]

  typeClientProfile: Array<any> = [
    {
      "key": "Projeto Attiva",
      "label": "Form.clientProfiles.attiva"
    },
    {
      "key": "Implantação",
      "label": "Form.clientProfiles.implantation"
    },
    {
      "key": "Sem Projeto",
      "label": "Form.clientProfiles.noProject"
    }
  ]

  contractTrain: Array<any> = [
    {
      "key": "Sim",
      "label": "Form.FieldIntegration.Yes"
    },
    {
      "key": "Não",
      "label": "Form.FieldIntegration.No"
    }
  ]

  erpList: Array<any> = [
    {
      "key": "Adsomos",
      "label": "Adsomos"
    },
    {
      "key": "Consistem",
      "label": "Consistem"
    },
    {
      "key": "Excia",
      "label": "Excia"
    },
    {
      "key": "Linx",
      "label": "Linx"
    },
    {
      "key": "Millennium",
      "label": "Millennium"
    },
    {
      "key": "New Century",
      "label": "New Century"
    },
    {
      "key": "Organiza têxtil",
      "label": "Organiza têxtil"
    },
    {
      "key": "Prorius",
      "label": "Prorius"
    },
    {
      "key": "Reverso",
      "label": "Reverso"
    },
    {
      "key": "Sisplan",
      "label": "Sisplan"
    },
    {
      "key": "Totvs",
      "label": "Totvs"
    },
    {
      "key": "Systêxtil",
      "label": "Systêxtil"
    },
    {
      "key": "Webpic - Dapic",
      "label": "Webpic - Dapic"
    },
    {
      "key": "Outros",
      "label": "Form.FieldIntegration.Other"
    }
  ]

  levelsUser = this.levels.concat({ "key": "Todos", "label": "Form.Levels.all" });



  form: any = {
    summary: '',
    impact: '',
    affected: '',
    urgency: '',
    project: '',
    process: '',
    benefit: '',
    situation: '',
    impact2: '',
    alternatives: '',
    solution: '',
    results: '',
    sector: '',
    clientSolicit: '',
    sectorClient: '',
    company: '',
    returnValue: '',
    otherbenefit: '',
    CustomerData: '',
    Customerneed: '',
    Currentbehavior: '',
    name: '',
    returnValueAnswer: '',
    country: '',
    subject: ''
  }

  integrationform: any = {
    companyName: '',
    contactClient: '',
    contactPhone: '',
    contactEmail: '',
    sectorClient: '',
    erp: '',
    contactErp: '',
    solicitationDate: '',
    startForecast: '',
    erpResponse:'',
    projectResponse:'',
    clientContractTrain: '',
    nameOtherErp: '',
    clientProfile: ''
  }

  canShow: boolean = true

  values: any = this.integration === "false" ? this.form : this.integrationform


  onSubmit(form) {
    var axios = require('axios');
    var data
    const formData = new FormData();

    // cai na regra do insights
    if(this.integration === "false"){
      var validBenefits = this.validBenefitJSON()
      var validProcesses = this.validProcessJson()
      var listBenefits = validBenefits
      var listProcesses = validProcesses

      var data1 = JSON.stringify({
        "fields":
        {
          "project": {
            "key": "CDDP"
          },

          "summary": this.form.summary,

          "description": {
            "version": 1,
            "type": "doc",
            "content": [
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Projeto"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.project
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Contato do cliente"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.CustomerData
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Situação Atual"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.situation
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Necessidade do cliente"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.Customerneed
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Impacto Atual"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.impact2
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Comportamento atual"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.Currentbehavior
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Alternativas Avaliadas"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.alternatives
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Solução Proposta"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.solution
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Resultados Esperados"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.results
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Descreva de forma clara como chegou neste valor aproximado de retorno financeiro para a Audaces, quais foram os dados analisados e como chegou nesse cálculo:"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.returnValueAnswer
                  }
                ]
              },

            ]
          },
          "issuetype": {
            "id": "10003",
            "name": "Tarefa"
          },

          "customfield_11018": this.user.name ? this.user.name : "",

          "components": [{ "name": this.form.project }],

          "customfield_10950": listProcesses,

          "customfield_10974": { "id": this.form.sector },

          "customfield_11011": { "id": this.form.sectorClient },

          "customfield_10958": [this.form.company.replace(" ", "-")],

          "customfield_11012": { "id": this.form.returnValue },

          "customfield_10951": listBenefits,

          "customfield_10953": { "value": this.form.affected },

          "customfield_10954": { "value": this.form.urgency },

          "customfield_10955": { "value": this.form.impact },

          "customfield_11039": `${this.form.country}`,

          "customfield_11040": { "id": this.form.subject }
        }

      });

      var data2 = JSON.stringify({
        "fields":
        {
          "project": {
            "key": "CDDP"
          },

          "summary": this.form.summary,
          "description": {
            "version": 1,
            "type": "doc",
            "content": [
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Projeto"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.project
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Situação Atual"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.situation
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Necessidade do cliente"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.Customerneed
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Impacto Atual"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.impact2
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Comportamento atual"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.Currentbehavior
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Alternativas Avaliadas"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.alternatives
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Solução Proposta"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.solution
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Resultados Esperados"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.results
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Descreva de forma clara como chegou neste valor aproximado de retorno financeiro para a Audaces, quais foram os dados analisados e como chegou nesse cálculo:"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.returnValueAnswer
                  }
                ]
              },

            ]
          },
          "issuetype": {
            "id": "10003",
            "name": "Tarefa"
          },

          "customfield_11018": this.user ? this.user.name : "",

          "components": [{ "name": this.form.project }],

          "customfield_10950": listProcesses,

          "customfield_10974": { "id": this.form.sector },

          "customfield_10958": ["Audaces"],

          "customfield_11012": { "id": this.form.returnValue },

          "customfield_10951": listBenefits,

          "customfield_10953": { "value": this.form.affected },

          "customfield_10954": { "value": this.form.urgency },

          "customfield_10955": { "value": this.form.impact },

          "customfield_11039": `${this.form.country}`,

          "customfield_11040": { "id": this.form.subject }
        }

      });

      if (this.form.clientSolicit == "Sim") {
        data = data1
      } else {
        data = data2
      }

      if (this.selectedFiles.length > 0) {
        for (let i = 0; i < this.selectedFiles.length; i++) {
          formData.append('files', this.selectedFiles[i]);
        }
      }
    }

    // cai na regra da integração
    if(this.integration === "true"){
      data = JSON.stringify({
        "fields":
        {
          "project": {
            "key": "IN"
          },

          "summary": this.integrationform.companyName,

          "description": {
            "version": 1,
            "type": "doc",
            "content": [
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Pessoa de contato"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.contactClient
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Telefone para contato"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.contactPhone
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "e-mail de contato"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.contactEmail
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Perfil do Cliente"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.clientProfile
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "ERP"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.erp == 'Outros' ? this.integrationform.nameOtherErp : this.integrationform.erp
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Pessoa responsável ERP"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.erpResponse
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Cliente contratou treinamento?"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.clientContractTrain
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Cliente já contactou ERP?"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.contactErp
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Pessoa Solicitante"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.user.name ? this.user.name : "",
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "País"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.form.country,
                  }
                ]
              },
              {
                "type": "heading",
                "attrs": {
                  "level": 3
                },
                "content": [
                  {
                    "type": "text",
                    "text": "Previsão de início"
                  }
                ]
              },
              {
                "type": "paragraph",
                "content": [
                  {
                    "type": "text",
                    "text": this.integrationform.startForecast,
                  }
                ]
              },
            ]
          },
          "issuetype": {
            "id": "10003",
            "name": "Tarefa"
          },

          "customfield_10508": this.integrationform.projectResponse,

        "customfield_10974": { "id": this.integrationform.sectorClient },

        "customfield_11024": this.integrationform.solicitationDate
        }
      });
    }


    formData.append('fields', data);

    const config = {
      method: 'post',
      url: environment.api_endpoint,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        'access_token': environment.api_token
      },
      data: formData,
    };

    axios(config)
      .then((response) => {
        form.resetForm();
        this.selectedFiles.length = 0
        this.showSuccess()
      })
      .catch((error) => {
        console.log(error);
      });
  };

  constructor(public oidcSecurityService: OidcSecurityService, private http: HttpClient, private translate: TranslateService, private toastr: ToastrService) {
    var currentLanguage = navigator.language;

    switch (currentLanguage) {
      case 'pt':
        currentLanguage = "pt-BR"
        break;
      case 'pt-BR':
        currentLanguage = "pt-BR"
        break;
      case 'es':
        currentLanguage = "es"
        break;
      case 'es-419':
        currentLanguage = "es"
        break;
      default:
        currentLanguage = "en"
        break;
    }


    this.oidcSecurityService.userData$.subscribe(userD => {
      this.user = userD

    })
    this.translate.setDefaultLang(currentLanguage);
    this.translate.use(currentLanguage);

  }

  showSuccess() {
    this.toastr.success('Formulário enviado!', 'Sucesso!');
  }

  validBenefitJSON() {

    interface benefitsArray {
      id: String
    }

    var validJSON: Array<benefitsArray> = []
    for (var i = 0; i < this.form.benefit.length; i++) {
      validJSON[i] = { id: this.form.benefit[i] }
    }

    // var string = JSON.stringify(validJSON).replace(/{"\d":|"\d":|}$/g, '')
    var string = validJSON
    return string
  }

  filteredSubjects: Array<any> = [];

  filterSubjects() {
    const selectedProject = this.form.project;
    this.filteredSubjects = this.subjects.filter(subject => subject.project === selectedProject);
  }

  validProcessJson() {

    interface processArray {
      id: String
    }

    var validJSON: Array<processArray> = []
    for (var i = 0; i < this.form.process.length; i++) {
      validJSON[i] = { id: this.form.process[i] }
    }
    var string = validJSON
    return string
  }

  onImageSelected(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file) {
        this.selectedFiles.push(file)
        // console.log(file);
      }
    }
  }


}





